import { initTextToggle } from '../../utils';

const ArticleHeader = () => initTextToggle('articleHeader');

export default ArticleHeader;
